import {Action} from '@ngrx/store';
import {ApiResponse} from '../../../../functions/src/data';
import {DashboardClientModel, DashboardProfessionalModel} from '../../../../functions/src/data/dashboard-model';

export enum ActionTypes {
  Init = '[Dashboard] Init dashboard',

  // Load dashboard data
  LoadDashboardData = '[Dashboard] Load dashboard data',
  LoadDashboardDataResponse = '[Dashboard] Load dashboard data response',
}

export class Init implements Action {
  readonly type = ActionTypes.Init;

  constructor() {
  }
}

export class LoadDashboardData implements Action {
  readonly type = ActionTypes.LoadDashboardData;
  constructor() {}
}

export class LoadDashboardDataResponse implements Action {
  readonly type = ActionTypes.LoadDashboardDataResponse;
  constructor(public payload: {response: ApiResponse<DashboardProfessionalModel | DashboardClientModel>}) {}
}


export type Actions = Init
  | LoadDashboardData
  | LoadDashboardDataResponse;
